import React from "react";
import { classnames, Icon } from "@culturehq/components";

import styles from "./trophy.module.scss";

type TrophyProps = {
  place: number;
};

const Trophy: React.FC<TrophyProps> = ({ place }) => (
  <Icon
    icon="trophy-star"
    className={classnames(styles.trophy, styles[`trophy-${place}`])}
  />
);

export default Trophy;
